const COMPANY = process.env.IS_HUDU ? 'https://www.hugendubel.com/' : '/de/category/60535/ueber_uns.html';
const PRIVACY = '/datenschutz';
const TERMS_AND_CONDITIONS = process.env.IS_HUDU ? 'https://m.hugendubel.de/de/shortcut/agb_kundenkarte' : '/agbs';
const IMPRINT = '/impressum';
const CONTACT = process.env.IS_HUDU ? '/de/category/5804/kontakt.html' : '/de/category/59475/kontakt_impressum.html';
const ORDER_RETURN = process.env.IS_HUDU
    ? 'https://www.hugendubel.de/rueckgabe'
    : '/de/category/59436/ruecksendung.html';

export { COMPANY, PRIVACY, TERMS_AND_CONDITIONS, IMPRINT, CONTACT, ORDER_RETURN };
